function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
import { getOptOutOptions } from '../create.customer.constants';
var NotificationPreferencesSectionController = /*#__PURE__*/function () {
  function NotificationPreferencesSectionController() {
    _classCallCheck(this, NotificationPreferencesSectionController);
    this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    this.notificationPreferencesModal = {};
    this.optOutOptions = getOptOutOptions();
  }
  return _createClass(NotificationPreferencesSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      this.initializeNotificationPreferencesModal();
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.updateCustomerModel(this.customerModel, this.notificationPreferencesModal);
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "updateCustomerModel",
    value: function updateCustomerModel(customerModel, notificationPreferences) {
      customerModel.NotificationCategoryPreferences = this.getNotificationPreferences(notificationPreferences);
    }
  }, {
    key: "getNotificationPreferences",
    value: function getNotificationPreferences(notificationPreferences) {
      return Object.keys(notificationPreferences).map(function (notificationCategoryId) {
        return {
          CustomerNotificationCategoryId: +notificationCategoryId,
          OptOutOptions: notificationPreferences[notificationCategoryId] || []
        };
      });
    }
  }, {
    key: "initializeNotificationPreferencesModal",
    value: function initializeNotificationPreferencesModal() {
      if (this.notificationCategoryPreferences.length) {
        this.notificationPreferencesModal = _objectSpread({}, this.notificationCategoryPreferences.reduce(function (acc, category) {
          var optOutOptions = category.optOutOptions.filter(function (option) {
            return option.value;
          }).map(function (option) {
            return option.value;
          });
          acc[category.customerNotificationCategoryId] = optOutOptions;
          return acc;
        }, {}));
      }
    }
  }]);
}();
export default {
  template: require('./notification.preferences.section.html'),
  bindings: {
    customerModel: '<',
    notificationCategoryPreferences: '<',
    onFormChanged: '&'
  },
  controller: NotificationPreferencesSectionController
};